import React, { useEffect } from "react";
import { ResponsivePie } from '@nivo/pie'
import { convertCost } from "../../../Utils/functions";

export const genderMockData = { //gender data mockup
    "Male": {
        "Total": 0,
        "Add": 480,
        "Used": 38,
        "AddPoint": 0,
        "UsedPoint": 0
    },
    "Female": {
        "Total": 0,
        "Add": 791,
        "Used": 150,
        "AddPoint": 0,
        "UsedPoint": 0
    }
}

const GenderChart = ({info,type}) => {
    const [data,setData] = React.useState([])//gender data

    //data parsing
    useEffect(() => {
        let newData = [];
        
        if(type === 'add'){
            newData = [
                {
                    'id' : '남자',
                    'value' : info.Male.Add
                },
                {
                    'id' : '여자',
                    'value' : info.Female.Add
                }
            ]
        }else {
            newData = [
                {
                    'id' : '남자',
                    'value' : info.Male.Used
                },
                {
                    'id' : '여자',
                    'value' : info.Female.Used
                }
            ]
        }

        setData(newData)
    },[type])

    useEffect(() => {
        let newData = [];
        
        if(type === 'add'){
            newData = [
                {
                    'id' : '남자',
                    'value' : info.Male.Add
                },
                {
                    'id' : '여자',
                    'value' : info.Female.Add
                }
            ]
        }else {
            newData = [
                {
                    'id' : '남자',
                    'value' : info.Male.Used
                },
                {
                    'id' : '여자',
                    'value' : info.Female.Used
                }
            ]
        }

        setData(newData)
    },[info])

    return (
        <div style={{ width : 412, height : 280 }}>
            <ResponsivePie
                data={data}
                margin={{ top: 30, right: 0, bottom: 0, left: 0 }}
                innerRadius={0.8}
                height={240}
                activeOuterRadiusOffset={8}
                borderColor={{
                    from: 'color',
                    modifiers: [
                        [
                            'darker',
                            0.2
                        ]
                    ]
                }}
                indexBy="id"
                colors={['#0064ff','#f95f53']}
                enableArcLinkLabels={false}
                arcLinkLabelsSkipAngle={10}
                arcLinkLabelsTextColor="#333333"
                arcLinkLabelsThickness={2}
                arcLinkLabelsColor={{ from: 'color' }}
                enableArcLabels={false}
                arcLabelsSkipAngle={10}
                arcLabelsTextColor={{
                    from: 'color',
                    modifiers: [
                        [
                            'darker',
                            2
                        ]
                    ]
                }}
                motionConfig="default"
                tooltip={(props) => {
                    return(
                        <div className='tooltip' style={{ flexDirection : 'column',alignItems : 'center', justifyContent : 'center',display : 'flex',backgroundColor : 'white', padding : 16, paddingTop : 16, paddingBottom : 1, borderRadius : 24, boxShadow : '0 12px 14px 0 rgba(0, 0, 0, 0.07)' }}>
                            {
                                Object.keys(props).length > 0 &&
                                <>
                                    <p style={{ fontSize : 12, fontWeight : 500, lineHeight : 1.5, color : '#3f3f3f'}}>{props.datum.id}</p>
                                    <p style={{ fontSize : 18, fontWeight : 'bold', lineHeight : 1.78, textAlign : 'center', color : '#f95f53'}}>{convertCost(props.datum.value)} 명</p>
                                </>
                            }
                        </div>
                    )
                }}
                legends={[
                    {
                        anchor: 'top-left',
                        direction: 'column',
                        justify: false,
                        translateX: 0,
                        translateY: -30,
                        itemsSpacing: 8,
                        itemWidth: 56,
                        itemHeight: 16,
                        itemTextColor: '#999',
                        itemDirection: 'left-to-right',
                        itemOpacity: 1,
                        symbolSize: 8,
                        symbolShape: 'circle',
                        effects: [
                            {
                                on: 'hover',
                                style: {
                                    itemTextColor: '#000'
                                }
                            }
                        ]
                    }
                ]}
            />
        </div>
    )
}

export default GenderChart;